import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { format } from 'date-fns';

@Directive({
    selector: '[appFormatDateToUtc]',
})
export class FormatDateToUtcDirective implements OnInit {
    @Input('appFormatDateToUtc') initialValue: any;
    @Output() appBsDateUtcChange = new EventEmitter<number>();

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        if (this.initialValue) {
            const initDate = new Date(this.initialValue);
            const initDateUtc = new Date(
                initDate.getFullYear(),
                initDate.getMonth(),
                initDate.getUTCDate(),
            );
            const formatted = format(initDateUtc, 'dd/MM/yyyy');
            this.setInputValue(formatted);
        }
    }

    @HostListener('bsValueChange', ['$event'])
    onBsValueChange(value: Date) {
        if (!value) return;

        const utcTimestamp = Date.UTC(
            value.getFullYear(),
            value.getMonth(),
            value.getDate(),
        );
        this.appBsDateUtcChange.emit(utcTimestamp);

        const formatted = format(new Date(utcTimestamp), 'dd/MM/yyyy');
        this.setInputValue(formatted);
    }

    private setInputValue(dateStr: string) {
        this.el.nativeElement.value = dateStr;
    }
}
